import { FaEuroSign, FaTachometerAlt, FaCalendarAlt } from 'react-icons/fa';




export const getPersonalDataFromLocalStorage = () => ({
  first_name: localStorage.getItem('aitomotivelab_personalData_first_name') || '',
  last_name: localStorage.getItem('aitomotivelab_personalData_last_name') || '',
  email: localStorage.getItem('aitomotivelab_personalData_email') || '',
  gdpr_consent: localStorage.getItem('aitomotivelab_personalData_gdpr') === 'gdpr',
  marketing_consent: localStorage.getItem('aitomotivelab_personalData_marketing') === 'marketing',
  phone: localStorage.getItem('aitomotivelab_personalData_phone') || '',
  api_token: localStorage.getItem('api_token') || ''
});


export const propertyMappings = {
  car_stock_search: {
    badge: 'usagetype',
    vehicleid: 'vehicleid',
    title: 'description',
    url: 'url',
    available:'available',
    image: 'urlmainimage',
    description1: 'km',
    description1Icon: FaTachometerAlt,
    description1String: 'km',
    description2: 'saleprice',
    description2Icon: FaEuroSign,
    description2String: '',
    description3: 'registrationyear',
    description3Icon: FaCalendarAlt,
    description3String: '',
    description4: 'retailprice',
    description4Icon: FaEuroSign,
    description4String: '',
    description5: 'sconto_attivo',
    description5Icon: FaEuroSign,
    description5String: '',
    descrizione_economica_promozione_ai: "descrizione_economica_promozione_ai",
    promotion: "promotion",
    promotion_document__url: "promotion_document__url",
    promotionDetails: "promotionDetails",
    link_promozione_promozione_ai: "link_promozione_promozione_ai"
  }
};

propertyMappings.car_configurator = propertyMappings.car_stock_search;


const fetchVehicleDataa = async (vehicleId) => {
  try {
    const response = await fetch(`https://apicore.smiledealer.it/vehicles/stocks/${localStorage.getItem("codice_concessionario")}/${vehicleId}/large/`);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching vehicle data:', error);
    return null;
  }
};


export const mapItems = (source, mappings) => 
  source
    .filter(car => car[mappings.vehicleid])  // Filter out cars without a vehicleid
    .map(car => {
      const mappedCar = {
        // Spread all original fields first so extra fields (catalog_token, fuel_type, etc.) are preserved
        ...car,
        vehicleid: car[mappings.vehicleid],
        badge: car[mappings.badge],
        title: car[mappings.title],
        url: car[mappings.url],
        image: car[mappings.image],
        available: car[mappings.available],
        description1Icon: mappings.description1Icon,
        description1String: mappings.description1String,
        description2Icon: mappings.description2Icon,
        description2String: mappings.description2String,
        description3: car[mappings.description3],
        description3Icon: mappings.description3Icon,
        description3String: mappings.description3String,

        description4: car[mappings.description4],
        description4Icon: mappings.description4Icon,
        description4String: mappings.description4String,

        description5: car[mappings.description5],
        description5Icon: mappings.description5Icon,
        description5String: mappings.description5String,

        descrizione_economica_promozione_ai: car[mappings.descrizione_economica_promozione_ai],
        promotion: car[mappings.promotion],
        promotionDetails: car[mappings.promotionDetails],
        promotion_document__url: car[mappings.promotion_document__url],
        link_promozione_promozione_ai: car[mappings.link_promozione_promozione_ai]
      };

      // Conditionally include description1 and description2
      if (car[mappings.description1] > 0) {
        mappedCar.description1 = car[mappings.description1];
      }
      if (car[mappings.description2] > 0) {
        mappedCar.description2 = car[mappings.description2];
      }
      if (car[mappings.description3] > 1990) {
        mappedCar.description3 = car[mappings.description3];
      }

      return mappedCar;
    });

/**
 * Formats a timestamp to WhatsApp-style format
 * @param {string} timestamp - ISO timestamp string (e.g., "2025-05-23T11:10:54.607Z")
 * @returns {string} - Formatted timestamp
 */
export const formatWhatsAppTimestamp = (timestamp) => {
  if (!timestamp) return '';
  
  try {
    const messageDate = new Date(timestamp);
    const now = new Date();
    
    // Helper function to check if two dates are the same day
    const isSameDay = (date1, date2) => {
      return date1.getDate() === date2.getDate() &&
             date1.getMonth() === date2.getMonth() &&
             date1.getFullYear() === date2.getFullYear();
    };
    
    // Helper function to check if date is yesterday
    const isYesterday = (date) => {
      const yesterday = new Date(now);
      yesterday.setDate(yesterday.getDate() - 1);
      return isSameDay(date, yesterday);
    };
    
    // Helper function to check if date is within current week
    const isThisWeek = (date) => {
      const weekStart = new Date(now);
      const dayOfWeek = now.getDay();
      const diff = now.getDate() - dayOfWeek + (dayOfWeek === 0 ? -6 : 1); // adjust when day is sunday
      weekStart.setDate(diff);
      weekStart.setHours(0, 0, 0, 0);
      
      return date >= weekStart && date < now;
    };
    
    // Format time as HH:MM
    const formatTime = (date) => {
      return date.toLocaleTimeString('it-IT', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
      });
    };
    
    // Format date for older messages
    const formatDate = (date) => {
      return date.toLocaleDateString('it-IT', {
        day: '2-digit',
        month: '2-digit',
        year: '2-digit'
      });
    };
    
    // Get day name in Italian
    const getDayName = (date) => {
      const days = ['Domenica', 'Lunedì', 'Martedì', 'Mercoledì', 'Giovedì', 'Venerdì', 'Sabato'];
      return days[date.getDay()];
    };
    
    if (isSameDay(messageDate, now)) {
      // Today: just show time (e.g., "14:30")
      return formatTime(messageDate);
    } else if (isYesterday(messageDate)) {
      // Yesterday: show "Ieri" + time (e.g., "Ieri 14:30")
      return `Ieri ${formatTime(messageDate)}`;
    } else if (isThisWeek(messageDate)) {
      // This week: show day name + time (e.g., "Martedì 14:30")
      return `${getDayName(messageDate)} ${formatTime(messageDate)}`;
    } else {
      // Older: show date + time (e.g., "23/05/25 14:30")
      return `${formatDate(messageDate)} ${formatTime(messageDate)}`;
    }
  } catch (error) {
    console.error('Error formatting timestamp:', error);
    return timestamp; // Fallback to original timestamp
  }
};